import type { FilterCategory } from './types';

/**
 * Fixed display order for the grouped "+ Add …" picker, shared by Filters and
 * Compare By. "Overall" is a synthetic Compare-By-only entry handled in the
 * CompareByPicker, not a category here.
 */
export const CATEGORY_ORDER: FilterCategory[] = ['quota', 'demographic', 'trip', 'question'];

/** Human-readable group headers for each category in the picker. */
export const CATEGORY_LABELS: Record<FilterCategory, string> = {
  demographic: 'Demographics',
  question: 'Questions',
  quota: 'Quota groups',
  trip: 'Trip attributes',
};

/** Max values selectable in a Compare By "values" group; the 11th is disabled, not hidden. */
export const MAX_COMPARE_VALUES = 10;

/** Max number of filter dimensions that can be added at once. */
export const MAX_FILTERS = 10;

/** At/below this option count a value list renders flat (no search); above it, a search box appears. */
export const CARDINALITY_THRESHOLD = 10;

/** Cap on rendered value rows; mirrors Cardify's 200-row guard with a "refine search" footer. */
export const LIST_RENDER_CAP = 200;

/** Max characters for a question/facet label before truncation (mirrors Cardify's MAX_QUESTION_LABEL). */
export const MAX_FACET_LABEL = 40;

/** Compare-By "Overall (no cut)" sentinel option value. */
export const NO_COMPARE_VALUE = '';

/** Info tooltip shown next to the Trip attributes group. */
export const TRIP_ATTRIBUTE_TOOLTIP =
  'Reflects the purchase that qualified the respondent for the survey.';
